import React from 'react';

import { KeyboardDatePicker, TimePicker } from "@material-ui/pickers";
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Button, Select, NativeSelect, FormControlLabel, RadioGroup, Radio, TextField, Typography, IconButton, Grid, OutlinedInput, Paper } from '@material-ui/core';
import { RadioButtonUnchecked, RadioButtonChecked, Close, QueryBuilder } from '@material-ui/icons';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import CalendarToday from '@material-ui/icons/CalendarToday';

import { equipmentTypeOptions } from '../../utils/equipmentOptions';
import addIcon from '../../assets/add.svg';
import RfsStyles from './rfs.module.css';
import commonStyles from '../common/common.module.css';

import OfflineRfsModel, { Point } from '../../models/OfflineRfs';
import AirlineType from '../../models/AirlineType';

const styles = (theme: Theme) =>

  createStyles({
    rfsPaper: {
      padding: '24px 32px',
      marginTop: '16px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      backgroundColor: '#fff',
      width: '100%',
      marginBottom: '30px'
    },
    sectionTitle: {
      color: 'var(--primaryblue)',
      fontWeight: 600,
      fontSize: '18px',
      marginBottom: '20px',
      borderBottom: '1px solid #eee',
      paddingBottom: '10px'
    },
    wrapper: {
      display: 'flex',
      marginBottom: '10px',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      padding: '25px',
      position: 'relative',
      '&:first-child': {
        marginBottom: '30px',
      },
    },
    wrapper1: {
      order: 1,
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      marginTop: '25px !important'
    },
    dateWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      '& > div:not(:last-child)': {
        marginRight: '10px',
        width: '100%',
      },
      '& svg': {
        fontSize: '19px  !important'
      }
    },
    blue: {
      color: 'var(--primaryblue)',
    },
    button: {
      height: '32px',
      textTransform: 'none'
    },
    inputWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    toUpperCase: {
      '& input': {
        textTransform: 'uppercase'
      }
    },
    datePickerInput: {
      '& input': {
        textTransform: 'uppercase',
      },
    },
    timer: {
      padding: '10px 0 7px',
      borderBottom: '1px solid rgba(170, 170, 170, 1)',
      paddingRight: '5px',
    },
    truckTypeLabel: {
      borderBottom: '1px solid rgba(170, 170, 170, 1)',
      marginBottom: '2px'
    },

    typeContainer: {
      display: 'flex',
      justifyContent: 'center'
    },

    truckTypeRadio: {
      '& p': {
        fontSize: '12px',
        color: '#003261',
        paddingLeft: '2px'
      },
      '&:last-child': {
        marginLeft: '-15px',
      }
    },
    equipmentSelect: {
    },
    btnWrapper: {
      paddingTop: '8px',
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%'
    },
    formControlFWd: {
      width: '95%',
    },
    dropDownFwdWrapper: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      marginLeft: 'auto',
      alignItems: 'baseline',
      marginTop: '0 !important',
      boxSizing: 'border-box',
      '&:before': {
        border: 'none'
      },
    },
    materialIcon: {
      width: 28,
      marginLeft: '10px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    dropDownWrapper: {
      display: 'flex',
      alignItems: 'flex-end'
    },
    root: {
      color: 'grey',
      height: '5px',
      fontSize: '0.875rem',
    },
    selected: {
      color: 'rgb(0, 50, 97) !important'
    },
    pointDetails: {
      marginTop: '10px',
      borderRadius: '5px',
      backgroundColor: '#f9f9f9',
      fontSize: '14px',
      '& p': {
        margin: '0'
      }
    },
    pointDetailsInner: {
      padding: '10px'
    },
    iconSize: {
      fontSize: '20px'
    },
    labelWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end'
    },
    radio: {
      justifyContent: 'center',
      marginTop: '5px',
      '& svg': {
        fontSize: '18px',
      }
    },
    radioBtn: {
      padding: 0
    },
    radioLabel: {
      borderBottom: '1px solid rgba(170, 170, 170, 1)',
      marginBottom: '2px'
    },
    customButton: {
      textTransform: 'inherit',
      padding: '4px 18px'
    }
  });

interface RfsSetupProps {
  classes: any;
  isPickUpDialogOpen: boolean;
  isDropOffDialogOpen: boolean;
  offlineRfs: OfflineRfsModel;
  handleChange: (type: string, event: any) => void;
  handleSubmit: () => void;
  errors: OfflineRfsModel;
  pickupPoints: Array<Point>;
  dropOffPoints: Array<Point>;
  openDialog: (boxType: string) => void;
  closeDialog: (boxType: string) => void;
  pickUp: Point;
  dropOff: Point;
  handleCreatePoint: (type: string) => void;
  isEditMode: boolean;
  getFlights: () => void;
  flights: Array<AirlineType>;
};

const paymentReportSearch = (props: RfsSetupProps) => {

  const airlines = props.flights.map((airline: AirlineType) => {
    return (<option value={airline.id} key={airline.id}>{airline.iata_code + '-' + airline.awb_code}</option>);
  });

  const { isPickUpDialogOpen, isDropOffDialogOpen, classes } = props;
  const { scheduleDate, scheduleTime, scheduleArrDate, arrivalTime } = props.offlineRfs;
  let colorsClass: string = classes.blue;
  let buttonText = (props.isEditMode) ? 'Update RFS' : 'Create RFS'

  const pickUpOptions: Array<JSX.Element> = props.pickupPoints.map((item: any, index) => {
    return <option key={index} value={item.id}>{item.name}</option>
  });

  const dropOffOptions: Array<JSX.Element> = props.dropOffPoints.map((item: any, index) => {
    return <option key={index} value={item.id}>{item.name}</option>
  });

  const equipmentOptions: Array<JSX.Element> = equipmentTypeOptions.map((item: { value: string, name: string }, index: number) => {
    return <option key={index} value={item.value}>{item.name}</option>
  });

  function getPointDetail(type: string) {
    if (type === 'pickUp') {
      var result = props.pickupPoints.find(obj => { return obj.id === parseInt(props.offlineRfs.pickUp) })
    } else {
      var result = props.dropOffPoints.find(obj => { return obj.id === parseInt(props.offlineRfs.dropOff) })
    }

    if (result && result.info) {

      return (
        <div className={classes.pointDetailsContainer}>
          <Typography component='p' variant='caption'>{result.name}</Typography>
          <Typography component='p' variant='caption'>{result.info.addr1}</Typography>
          <Typography component='p' variant='caption'>{result.info.addr2}</Typography>
          <Typography component='p' variant='caption'>{result.info.city + ', ' + result.info.state + ' ' + result.info.zip}</Typography>
        </div>
      )
    }
  }


  return (
    <div>
      <div className={`${commonStyles.wrapper}` } >
        <h3 className={commonStyles.header}>
           SetUp RFS
        </h3>

        <Grid container spacing={3}>

          <Grid item xl={1} lg={1} md={2} sm={6} xs={12}>
            <TextField
              fullWidth
              label="Origin"
              value={ props.offlineRfs.org }
              onChange={ (event) => props.handleChange('org', event) }
              variant="outlined"
              disabled
              InputProps={{ 
                classes: { notchedOutline: RfsStyles.noNotch,
                  input: RfsStyles.toUpperCase },
              }}
              helperText={ props.errors.org }
              error={ props.errors.org !== '' }
              className={RfsStyles.textField}
              InputLabelProps={{ 
                shrink: true,
                className: RfsStyles.labelProp
               }}
            />
          </Grid>

          <Grid item xl={1} lg={1} md={2} sm={6} xs={12}>
            <TextField
              fullWidth
              label="Destination"
              value={ props.offlineRfs.dst }
              onChange={ (event) => props.handleChange('dst', event) }
              onBlur={ () => props.getFlights() }
              variant="outlined"
              helperText={ props.errors.dst }
              error={ props.errors.dst !== '' }
              className={RfsStyles.textField}
              InputLabelProps={{ 
                shrink: true,
                className: RfsStyles.labelProp
               }}
              InputProps={{ 
                classes: { notchedOutline: RfsStyles.noNotch,
                  input: RfsStyles.toUpperCase },
              }}
            />
          </Grid>

          <Grid item xl={1} lg={1} md={2} sm={6} xs={12}>
              <FormControl variant="outlined" fullWidth className={RfsStyles.textField}>
                <InputLabel shrink className={RfsStyles.labelProp}>Airline</InputLabel>
                <Select
                  native
                  label="Airline"
                  onChange={ (event) => props.handleChange('flight', event) }
                  value={ props.offlineRfs.airline ? props.offlineRfs.airline : '' }
                  className={RfsStyles.textField}
                  inputProps={{ classes: { notchedOutline: RfsStyles.noNotch},}}
                >
                  <option value="" />
                  { airlines }
                </Select>
              </FormControl>
          </Grid>

          <Grid item xl={1} lg={1} md={2} sm={6} xs={12}>
             <TextField
                fullWidth
                label="RFS Number"
                value={ props.offlineRfs.rfsNumber }
                onChange={ (event) => props.handleChange('rfsNumber', event) }
                variant="outlined"
                className={RfsStyles.textField}
                helperText={ props.errors.rfsNumber }
                error={ props.errors.rfsNumber !== '' }
                InputLabelProps={{ 
                  shrink: true, 
                  className: RfsStyles.labelProp
                }}
                InputProps={{ classes: { notchedOutline: RfsStyles.noNotch } }}
              />
          </Grid>

          <Grid item xl='auto' lg='auto' md='auto' sm={6} xs={12}>
            <div className={RfsStyles.radioWrapper}>
              <Typography variant='inherit' className={RfsStyles.checkboxLabel}>Truck Type</Typography>
              <RadioGroup
                name="truckType"
                value={ props.offlineRfs.truckType }
                row
                onChange={ (event) => props.handleChange('truckType', event) }
              >
                <FormControlLabel
                  value="EUV"
                  control={<Radio color="primary" size="small" className={RfsStyles.radioIcon} />}
                  label={<span className={RfsStyles.radioLabel}>EUV</span>}
                  className={commonStyles.mr3}
                />
                <FormControlLabel
                  value="LTL"
                  control={<Radio color="primary" size="small" className={RfsStyles.radioIcon} />}
                  label={<span className={RfsStyles.radioLabel}>LTL</span>}
                />
              </RadioGroup>
            </div>
          </Grid>

          {/* Row 2: Equipment & Dates */}

          <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
             <FormControl variant="outlined" fullWidth className={RfsStyles.textField}>
                <InputLabel shrink className={RfsStyles.labelProp}>Equipment</InputLabel>
                <Select
                  native
                  label="Equipment"
                  onChange={ (event) => props.handleChange('equipment', event) }
                  value={ props.offlineRfs.equipment ? props.offlineRfs.equipment : '' }
                  className={RfsStyles.textField}
                  inputProps={{ classes: { notchedOutline: RfsStyles.noNotch},}}
                >
                  <option value={-1} />
                  { equipmentOptions }
                </Select>
             </FormControl>
          </Grid>

          <Grid item xl lg md={6} sm={6} xs={12}>
             <Grid container spacing={1}>
                <Grid item xs={7}>
                    <KeyboardDatePicker
                      label="Scheduled Dept"
                      value={ scheduleDate }
                      format={ 'DD MMM YYYY' }
                      onChange={ (date: any) => props.handleChange('scheduleDate', date) }
                      inputVariant='outlined'
                      fullWidth
                      className={RfsStyles.textField}
                      InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                      InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                    />
                </Grid>
                <Grid item xs={5}>
                    <TimePicker
                      label="Time"
                      format='HH:mm'
                      value={ scheduleTime }
                      onChange={ (date) => { props.handleChange('scheduleTime', date) } }
                      inputVariant='outlined'
                      fullWidth
                      className={RfsStyles.textField}
                      InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                      InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                    />
                </Grid>
             </Grid>
          </Grid>

          <Grid item xl lg md={6} sm={6} xs={12}>
             <Grid container spacing={1}>
                <Grid item xs={7}>
                    <KeyboardDatePicker
                      label="Scheduled Arrival"
                      value={ scheduleArrDate }
                      format={ 'DD MMM YYYY' }
                      onChange={ (date) => props.handleChange('arrivalDate', date) }
                      minDate={ scheduleDate }
                      inputVariant='outlined'
                      fullWidth
                      className={RfsStyles.textField}
                      InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                      InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                    />
                </Grid>
                <Grid item xs={5}>
                    <TimePicker
                      label="Time"
                      format='HH:mm'
                      value={ arrivalTime } // Note: Check if 'arrivalTime' prop exists or map correctly
                      onChange={(date) => props.handleChange('arrivalTime', date)}
                      inputVariant='outlined'
                      fullWidth
                      className={RfsStyles.textField}
                      InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                      InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                    />
                </Grid>
             </Grid>
          </Grid>


        </Grid>
      </div>

      <div className={`${commonStyles.wrapper}` } >
        <h3 className={commonStyles.header}>
          Address
        </h3>

        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            {isPickUpDialogOpen ? (
                <div>
                  <div className={ RfsStyles.overlay } onClick={ (events) => props.closeDialog("PickUp") }></div>
                  <div className={ RfsStyles.attachmentsWrapper }>
                    <div className={ RfsStyles.attachmentsHeader }>
                      <div className={ RfsStyles.attachmentsHeaderText }>Add New Pick Up Point </div>
                      <div className={ RfsStyles.attachmentsButton } onClick={ (events) => props.closeDialog("PickUp") } >
                        <IconButton aria-label="Close">
                          <Close color='primary' />
                        </IconButton>
                      </div>
                    </div>
                    <div className={ RfsStyles.attachmentsBody } >
                      <div className={ [commonStyles.wrapper, RfsStyles.wrapper].join(' ') }>

                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Name of Pick Up Point</label>
                          <TextField
                            id="pick-up-point-name"
                            label=""
                            helperText={ props.errors.org !== '' ? props.errors.org + ` Name of Pick Up Point` : '' }
                            value={ props.pickUp.name }
                            onChange={ (event) => props.handleChange('puName', event) }
                            InputProps={{
                              classes: { 
                                root: classes.inputtextField,
                                notchedOutline: RfsStyles.noNotch
                              },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Address 1</label>
                          <TextField
                            id="pick-up-point-address1"
                            label=""
                            helperText={ props.errors.org !== '' ? props.errors.org + ` Address 1` : '' }
                            value={ props.pickUp.addr1 }
                            onChange={ (event) => props.handleChange('puAddr1', event) }
                            InputProps={{
                              classes: { 
                                root: classes.inputtextField,
                                notchedOutline: RfsStyles.noNotch
                               },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Address 2</label>
                          <TextField
                            id="pick-up-point-address2"
                            label=""
                            value={ props.pickUp.addr2 }
                            onChange={ (event) => props.handleChange('puAddr2', event) }
                            InputProps={{
                              classes: { root: classes.inputtextField },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>City</label>
                          <TextField
                            id="pick-up-point-city"
                            label=""
                            value={ props.pickUp.city }
                            onChange={ (event) => props.handleChange('puCity', event) }
                            InputProps={{
                              classes: { root: classes.inputtextField },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>State</label>
                          <TextField
                            id="pick-up-point-state"
                            label=""
                            value={ props.pickUp.state }
                            onChange={ (event) => props.handleChange('puState', event) }
                            InputProps={{
                              classes: { root: classes.inputtextField },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Zip Code</label>
                          <TextField
                            id="pick-up-point-zip"
                            label=""
                            value={ props.pickUp.zip }
                            onChange={ (event) => props.handleChange('puZip', event) }
                            InputProps={{
                              classes: { root: classes.inputtextField },
                            }}
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ classes.btnWrapper }>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={ (events) => props.handleCreatePoint('pickUp') }
                            disableElevation
                            className={ classes.customButton } 
                          >
                            Add Pick Up Point
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            ) : (
                <div className={`${RfsStyles.flexColumn} ${commonStyles.h100}`} >
                  <div className={ RfsStyles.alignCenter }>
                     <FormControl variant="outlined" fullWidth className={RfsStyles.textField}>
                        <InputLabel shrink className={RfsStyles.labelProp}>Pick Up From</InputLabel>
                        <Select
                          native
                          label="Pick Up From"
                          onChange={ (event) => props.handleChange('pickUp', event) }
                          value={ props.offlineRfs.pickUp || '' }
                          inputProps={{ classes: { notchedOutline: RfsStyles.noNotch},}}
                        >
                          <option value="" />
                          { pickUpOptions }
                        </Select>
                     </FormControl>
                     <IconButton onClick={ (events) => props.openDialog("PickUp") } color="primary" className={RfsStyles.addAddress}>
                        <img alt="Add" src={ addIcon } width={'24px'} height={'24px'} />
                     </IconButton>
                  </div>
                  { props.offlineRfs.pickUp && (
                     <div className={ [classes.pointDetailsInner, RfsStyles.pointDetails].join(' ') }>
                        { getPointDetail('pickUp') }
                     </div>
                  )}
                </div>
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            {isDropOffDialogOpen ? (
               <div>
                  <div className={ RfsStyles.overlay } onClick={ (events) => props.closeDialog("DropOff") }></div>
                  <div className={ RfsStyles.attachmentsWrapper }>
                    <div className={ RfsStyles.attachmentsHeader }>
                      <label className={ RfsStyles.attachmentsHeaderText }> Add New Drop Off Point </label>
                      <div className={ RfsStyles.attachmentsButton } onClick={(events) => props.closeDialog("DropOff")} >
                        <IconButton aria-label="Close">
                          <Close color='primary' />
                        </IconButton>
                      </div>
                    </div>
                    <div className={ RfsStyles.attachmentsBody } >
                      <div className={ [commonStyles.wrapper, RfsStyles.wrapper].join(' ') }>

                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Name of drop off point</label>
                          <TextField
                            id="drop-off-point-name"
                            label=""
                            value={ props.dropOff.name }
                            onChange={ (event) => props.handleChange('doName', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Address 1</label>
                          <TextField
                            id="drop-off-point-address1"
                            label=""
                            value={ props.dropOff.addr1 }
                            onChange={ (event) => props.handleChange('doAddr1', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign, commonStyles.w100].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Address 2</label>
                          <TextField
                            id="drop-off-point-address2"
                            label=""
                            value={ props.dropOff.addr2 }
                            onChange={ (event) => props.handleChange('doAddr2', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>City</label>
                          <TextField
                            id="drop-off-point-city"
                            label=""
                            value={ props.dropOff.city }
                            onChange={ (event) => props.handleChange('doCity', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>State</label>
                          <TextField
                            id="drop-off-point-state"
                            label=""
                            value={ props.dropOff.state }
                            onChange={ (event) => props.handleChange('doState', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ [classes.inputWrapper, RfsStyles.inputAlign].join(' ') } >
                          <label className={ commonStyles.inputLabel }>Zip Code</label>
                          <TextField
                            id="drop-off-point-zip"
                            label=""
                            value={ props.dropOff.zip }
                            onChange={ (event) => props.handleChange('doZip', event) }
                            variant="outlined"
                            fullWidth
                          />
                        </div>
                        <div className={ classes.btnWrapper }>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={ (events) => props.handleCreatePoint('dropOff') }
                            disableElevation
                            className={ classes.customButton }
                          >
                            Add Drop Off Point
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            ) : (
                <div className={`${RfsStyles.flexColumn} ${commonStyles.h100}`} >
                  <div className={ RfsStyles.alignCenter }>
                     <FormControl variant="outlined" fullWidth className={RfsStyles.textField}>
                        <InputLabel shrink className={RfsStyles.labelProp}>Drop Off To</InputLabel>
                        <Select
                          native
                          label="Drop Off To"
                          onChange={ (event) => props.handleChange('dropOff', event) }
                          value={ props.offlineRfs.dropOff || '' }
                          inputProps={{ classes: { notchedOutline: RfsStyles.noNotch},}}
                        >
                          <option value="" />
                          { dropOffOptions }
                        </Select>
                     </FormControl>
                     <IconButton onClick={ (events) => props.openDialog("DropOff") } color="primary" className={RfsStyles.addAddress}>
                        <img alt="Add" src={ addIcon }  width="24px" height="24px" />
                     </IconButton>
                  </div>
                  { props.offlineRfs.dropOff && (
                     <div className={ [classes.pointDetailsInner, RfsStyles.pointDetails].join(' ') }>
                        { getPointDetail('dropOff') }
                     </div>
                  ) }
                </div>
            )}
          </Grid>
        </Grid>
      </div>

      <div className={ `${classes.btnWrapper} ${RfsStyles.footerButtonWrapper}` }>
        <Button
          color="primary"
          variant="contained"
          onClick={ props.handleSubmit }
          disableElevation
          className={ classes.customButton }
        >
          { buttonText }
        </Button>
      </div>

    </div>
  )
};

export default withStyles(styles)(paymentReportSearch);